export const GetParameter = (api, paramName, paramType, isEncrypted) => { //paramType = (num, char, date, bool)
    const tmpIsEncrypted = isEncrypted ? true : false
    return api.get(`api/v1/Parameter/GetParameter?paramName=${paramName}&paramType=${paramType}&isEncrypted=${tmpIsEncrypted}`)
}

export const GetParameterForSite = (api, paramName, paramType, siteId) => {
    return api.get(`api/v1/Parameter/getParameterForSiteFromEhandelDb?paramName=${paramName}&paramType=${paramType}&siteId=${siteId}`)
}

export const IsWorkingDay = (api, date) => {
    var data = {
        Date: date,
    }
    return api.post(`api/v1/Parameter/isWorkingDay`, data)
}

export const GetLicense = (api) => {
    return api.get('api/v1/Parameter/getLicense')
}

export const GetActivePaymentSuppliersForSites = (api) => {
    return api.get(`api/v1/Parameter/getActivePaymentSuppliersForSites`)
}

export const GetAllParameters = (api) => {
    return api.get('api/v1/Parameter/getAllParameters')
}

export const GetAllSiteParameters = (api) => {
    return api.get('api/v1/Parameter/getAllSiteParameters')
}

// paramType pochodzi wprost z kolumny ParamsForSite.ParamType
// (char | num | bool | text | date | password | url | email | time)
export const UpdateSiteParameter = (api, paramId, siteId, paramType, value) => {
    return api.put('api/v1/Parameter/updateSiteParameter', {
        paramId,
        siteId,
        paramType,
        value,
    })
}

// paramType pochodzi wprost z kolumny Params.ParamType
// (char | num | bool | text | date | password | url | email | time)
export const UpdateParameter = (api, paramId, paramType, value) => {
    return api.put('api/v1/Parameter/UpdateParameter', {
        paramId,
        paramType,
        value,
    })
}

export const GetNavBarItems = (api) => {
    return api.get('api/v1/Parameter/getNavBarItems')
}

export const DeleteNavBarItem = (api, id) => {
    return api.delete(`api/v1/Parameter/deleteNavBarItem?id=${id}`)
}

export const AddNavBarItem = (api, item) => {
    return api.post('api/v1/Parameter/addNavBarItem', item)
}

export const GetHomePageSliderItems = (api) => {
    return api.get('api/v1/Parameter/getHomePageSliderItems')
}

export const AddHomePageSliderItem = (api, item) => {
    return api.post('api/v1/Parameter/addHomePageSliderItem', item)
}

export const UpdateHomePageSliderItem = (api, item) => {
    return api.post('api/v1/Parameter/updateHomePageSliderItem', item)
}

export const DeleteHomePageSliderItem = (api, id) => {
    return api.delete(`api/v1/Parameter/deleteHomePageSliderItem?id=${id}`)
}

export const GetFooterElements = (api) => {
    return api.get('api/v1/Parameter/getFooderElements')
}

export const AddFooterItem = (api, item) => {
    return api.post('api/v1/Parameter/addFooterItem', item)
}

export const AddFooterHeader = (api, header) => {
    return api.post('api/v1/Parameter/addFooterHeader', header)
}

export const UpdateFooterItem = (api, item) => {
    return api.post('api/v1/Parameter/updateFooterItem', item)
}

export const UpdateFooterHeader = (api, header) => {
    return api.post('api/v1/Parameter/updateFooterHeader', header)
}

export const DeleteFooterItem = (api, id) => {
    return api.delete(`api/v1/Parameter/deleteFooterItem?id=${id}`)
}

export const DeleteFooterHeader = (api, id) => {
    return api.delete(`api/v1/Parameter/deleteFooterHeader?id=${id}`)
}